// extracted by mini-css-extract-plugin
module.exports = {"JobSearch":"styles_JobSearch__TJJem","list":"styles_list__SRtpU","list-item":"styles_list-item__w23tj"};